/**
 * Access control utility functions for checking permissions based on user roles
 */

/**
 * Check if user role has access to a particular resource
 * @param {string} userRole - The user's role (case insensitive)
 * @param {string[]} allowedRoles - Array of roles allowed to access the resource
 * @returns {boolean} - True if user has access, false otherwise
 */
export const hasRoleAccess = (userRole, allowedRoles) => {
  if (!userRole || !allowedRoles || !Array.isArray(allowedRoles)) {
    return false;
  }
  
  const normalizedUserRole = userRole.toLowerCase();
  const normalizedAllowedRoles = allowedRoles.map(role => role.toLowerCase());
  
  return normalizedAllowedRoles.includes(normalizedUserRole);
}; 

